import React, { useEffect, useState } from "react";
import "./App.scss";
import "./css/md.scss";
import "./css/sm.scss";
import "./css/xl.scss";
import "./css/xs.scss";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./components/home/Home";
import Navigation from "./components/fixed/Navigation";
import Login from "./components/login/login";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "./redux/store";
import PrivateRoute from "./components/guard/guard";
import Password from "./components/password/Setpassword";
import CreateActualite from "./components/actualite/CreateActualite";
import { login, setLoading, verifyToken } from "./redux/actions/authActions";
import ListActualite from "./components/actualite/ListActualite";
import CreateAgenda from "./components/agenda/CreateAgenda";
import ListAgednda from "./components/agenda/ListAgenda";
import EditActualite from "./components/actualite/EditActualite";
import Test from "./Test";
import EditAgenda from "./components/agenda/EditAgenda";
import MonPlanning from "./components/emission/ListUserEmission";
import UpdateUSerEmission from "./components/emission/EditUserEmission";
import ListAllEmission from "./components/emission/ListAllEmission";
import UpdateFullEmission from "./components/emission/EditFullEmission";
import ListAllMusic from "./components/music/ListMusic";
import EditMusic from "./components/music/EditMusic";
import { Spinner } from "react-rainbow-components";
import EdiTop30 from "./components/music/EditTop30";
import CreatePodcast from "./components/podcast/CreatePodcast";
import ListPotcast from "./components/podcast/ListPotcast";
import EditPodcast from "./components/podcast/EditPodcast";

const App: React.FC = () => {
  const [interval, setCustomInterval] = useState<any>();
  const { loading, authenticated, user } = useSelector(
    (state: RootState) => state.auth
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoading(true));
    const verifyLogin = async () => {
      await dispatch(login(null));
    };
    verifyLogin();
  }, []);

  useEffect(() => {
    if (authenticated) {
      dispatch(setLoading(false));
      setCustomInterval(
        setInterval(() => {
          const verifyLogin = async () => {
            await dispatch(verifyToken());
          };
          verifyLogin();
        }, 60000)
      );
    } else {
      setCustomInterval(clearInterval(interval));
    }
  }, [authenticated]);

  if (loading === true || loading === null) {
    return (
      <div className="h-100vh d-flex justify-content-center align-content-center align-middle ">
        <Spinner size="large" />
      </div>
    );
  }
  return (
    <Router>
      {authenticated ? <Navigation /> : null}
      <Switch>
        <Route path="/login" exact={true} component={Login} />

        <PrivateRoute path="/" exact={true} component={Home} />
        <PrivateRoute
          path="/actualite/create"
          exact={true}
          component={
            user?.adminRole?.info.create === 1 ? CreateActualite : Test
          }
        />
        <PrivateRoute
          path="/actualite/list"
          exact={true}
          component={user?.adminRole?.info.update === 1 ? ListActualite : Test}
        />
        <PrivateRoute
          path="/actualite/edit"
          exact={true}
          component={
            user?.adminRole?.agenda.update === 1 ? EditActualite : Test
          }
        />

        <PrivateRoute
          path="/agenda/list"
          exact={true}
          component={user?.adminRole?.agenda.update === 1 ? ListAgednda : Test}
        />
        <PrivateRoute
          path="/agenda/create"
          exact={true}
          component={user?.adminRole?.agenda.create === 1 ? CreateAgenda : Test}
        />
        <PrivateRoute
          path="/agenda/edit"
          exact={true}
          component={user?.adminRole?.agenda.update === 1 ? EditAgenda : Test}
        />

        <PrivateRoute
          path="/emission/monplanning"
          exact={true}
          component={MonPlanning}
        />
        <PrivateRoute
          path="/emission/updateemission"
          exact={true}
          component={UpdateUSerEmission}
        />
        <PrivateRoute
          path="/emission/listallemission"
          exact={true}
          component={ListAllEmission}
        />
        <PrivateRoute
          path="/emission/updatefullemission"
          exact={true}
          component={UpdateFullEmission}
        />

        <PrivateRoute
          path="/music/list"
          exact={true}
          component={ListAllMusic}
        />
        <PrivateRoute path="/music/edit" exact={true} component={EditMusic} />
        <PrivateRoute path="/music/top30" exact={true} component={EdiTop30} />

        <PrivateRoute
          path="/podcast/createpodcast"
          exact={true}
          component={CreatePodcast}
        />

        <PrivateRoute
          path="/podcast/list"
          exact={true}
          component={ListPotcast}
        />
        <PrivateRoute
          path="/podcast/edit"
          exact={true}
          component={EditPodcast}
        />

        <Route path="/resetpassword" exact={true} component={Password} />
      </Switch>
    </Router>
  );
};

export default App;
